var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAgenticAi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1677",
    "data-name": "Group 1677",
    transform: "translate(-105.04 -7442)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_242",
    "data-name": "Rectangle 242",
    width: 22,
    height: 22,
    transform: "translate(105.04 7442)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_474",
    "data-name": "Group 474"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_472",
    "data-name": "Group 472"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_471",
    "data-name": "Group 471"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_282",
    "data-name": "Path 282",
    d: "M124.947,7449.117h-1.393a8,8,0,0,0-15.028,0h-1.393a1.375,1.375,0,0,0-1.371,1.371v2.74a1.375,1.375,0,0,0,1.371,1.371h1.712a.479.479,0,0,0,.366-.183.443.443,0,0,0,.068-.411,6.91,6.91,0,0,1,0-4.294,7.083,7.083,0,0,1,13.5,0,6.891,6.891,0,0,1,0,4.294,7.038,7.038,0,0,1-6.737,4.933h-3.426a1.6,1.6,0,0,0,0,3.2H114.9a1.589,1.589,0,0,0,1.6-1.6v-.708a7.955,7.955,0,0,0,7.057-5.23h1.393a1.374,1.374,0,0,0,1.37-1.371v-2.74A1.374,1.374,0,0,0,124.947,7449.117Zm-16.695,4.568h-1.119a.458.458,0,0,1-.457-.457v-2.74a.458.458,0,0,1,.457-.457h1.119a8.206,8.206,0,0,0,0,3.654Zm7.331,6.852a.673.673,0,0,1-.685.685h-2.284a.685.685,0,0,1,0-1.37h2.969Zm9.821-7.309a.458.458,0,0,1-.457.457h-1.119a8.245,8.245,0,0,0,0-3.654h1.119a.458.458,0,0,1,.457.457Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_473",
    "data-name": "Group 473"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_283",
    "data-name": "Path 283",
    d: "M116.081,7454.621l-.334-1h-2.216l-.334,1h-1.184l1.947-5.561h1.358l1.955,5.561Zm-2.2-2.025h1.526l-.763-2.273Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_284",
    "data-name": "Path 284",
    d: "M117.809,7449.06h1.1v5.561h-1.1Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAgenticAi);
export default __webpack_public_path__ + "static/media/icon-agentic-ai.186dba365bc6eda86bccb00f529fbe0f.svg";
export { ForwardRef as ReactComponent };